export const ROOM_BUTTONS_HEIGHT = 92;

export const SIDEBAR_HEADER_HEIGHT = 65;

export const PINNED_VIDEO_WIDTH_PERCENT = 70;
export const PINNED_CONTENT_WIDTH_PERCENT = 100 - PINNED_VIDEO_WIDTH_PERCENT;

export const MOBILE_PINNED_VIDEO_HEIGHT_PERCENT = 60;
export const MOBILE_PINNED_CONTENT_HEIGHT_PERCENT = 100 - MOBILE_PINNED_VIDEO_HEIGHT_PERCENT;